import { apiGet } from '@/store/api';
import { EmailGenerationStatus, isEmailGenerationStatus } from './getEmailGenerationStatus';

export interface PendingEmailGeneration extends EmailGenerationStatus {
  DQU_ID: string;
}

export async function getPendingEmailGenerations(location: string, locationId: number | string): Promise<PendingEmailGeneration[]> {
  const result: unknown = await apiGet(`document/email-generations/${location}/${locationId}`);
  const jobs = result !== null && typeof result === 'object' && 'payload' in result ? result.payload : result;
  if (!Array.isArray(jobs) || !jobs.every((job): job is PendingEmailGeneration =>
    isEmailGenerationStatus(job) && 'DQU_ID' in job && typeof job.DQU_ID === 'string')) {
    throw new Error('Invalid pending email generations response.');
  }
  return jobs;
}